import React from 'react';
import { Link } from 'react-router-dom';
import { BarChartIcon, TrendingUpIcon, MessageSquareIcon, PackageIcon, UsersIcon, ClockIcon, BellIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
export function Dashboard() {
  // Mock user data
  const user = {
    name: 'John Doe',
    role: 'buyer',
    company: 'ABC Manufacturing'
  };
  // Mock statistics based on user role
  const stats = user.role === 'buyer' ? [{
    name: 'Active Orders',
    value: '12',
    icon: PackageIcon,
    color: 'bg-blue-500'
  }, {
    name: 'Suppliers',
    value: '8',
    icon: UsersIcon,
    color: 'bg-green-500'
  }, {
    name: 'Messages',
    value: '24',
    icon: MessageSquareIcon,
    color: 'bg-purple-500'
  }, {
    name: 'Saved Items',
    value: '16',
    icon: CheckCircleIcon,
    color: 'bg-amber-500'
  }] : [{
    name: 'Active Orders',
    value: '28',
    icon: PackageIcon,
    color: 'bg-blue-500'
  }, {
    name: 'Customers',
    value: '42',
    icon: UsersIcon,
    color: 'bg-green-500'
  }, {
    name: 'Messages',
    value: '17',
    icon: MessageSquareIcon,
    color: 'bg-purple-500'
  }, {
    name: 'Products',
    value: '35',
    icon: CheckCircleIcon,
    color: 'bg-amber-500'
  }];
  // Mock recent activity
  const recentActivity = [{
    id: 1,
    type: 'message',
    description: 'New message from Eco Packaging Inc.',
    time: '10 minutes ago',
    icon: MessageSquareIcon,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: 2,
    type: 'order',
    description: 'Order #38492 has been shipped',
    time: '2 hours ago',
    icon: PackageIcon,
    color: 'bg-green-100 text-green-600'
  }, {
    id: 3,
    type: 'alert',
    description: 'Price update for cardboard boxes',
    time: 'Yesterday',
    icon: BellIcon,
    color: 'bg-amber-100 text-amber-600'
  }, {
    id: 4,
    type: 'issue',
    description: 'Delay notification for order #37291',
    time: '2 days ago',
    icon: AlertCircleIcon,
    color: 'bg-red-100 text-red-600'
  }];
  // Mock recommended products/suppliers based on user role
  const recommendations = user.role === 'buyer' ? [{
    id: 1,
    name: 'Premium Cardboard Boxes',
    supplier: 'BoxMaster Inc.',
    image: 'https://images.unsplash.com/photo-1607344645866-009c320c5ab8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }, {
    id: 2,
    name: 'Eco-Friendly Mailers',
    supplier: 'Green Packaging Co.',
    image: 'https://images.unsplash.com/photo-1676299081847-824916254791?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }, {
    id: 3,
    name: 'Custom Printed Tape',
    supplier: 'BrandPack Solutions',
    image: 'https://images.unsplash.com/photo-1635405074683-96d6921a2a68?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }] : [{
    id: 1,
    name: 'ABC Manufacturing',
    interest: 'Cardboard Boxes',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }, {
    id: 2,
    name: 'Organic Foods Ltd.',
    interest: 'Eco-Friendly Packaging',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }, {
    id: 3,
    name: 'Tech Gadgets Inc.',
    interest: 'Custom Packaging',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80'
  }];
  return <div className="space-y-6" data-id="element-131">
      {/* Welcome Header */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-132">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-133">
          Welcome back, {user.name}
        </h1>
        <p className="text-gray-500 mt-1" data-id="element-134">
          {user.company} •{' '}
          {user.role === 'buyer' ? 'Buyer Dashboard' : 'Supplier Dashboard'}
        </p>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-135">
        {stats.map(stat => {
        const Icon = stat.icon;
        return <div key={stat.name} className="bg-white rounded-lg shadow p-6" data-id="element-136">
              <div className="flex items-center" data-id="element-137">
                <div className={`${stat.color} rounded-md p-3`} data-id="element-138">
                  <Icon className="h-6 w-6 text-white" data-id="element-139" />
                </div>
                <div className="ml-4" data-id="element-140">
                  <h2 className="text-2xl font-bold text-gray-900" data-id="element-141">
                    {stat.value}
                  </h2>
                  <p className="text-gray-500" data-id="element-142">{stat.name}</p>
                </div>
              </div>
            </div>;
      })}
      </div>
      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-143">
        {/* Recent Activity */}
        <div className="lg:col-span-2 bg-white rounded-lg shadow" data-id="element-144">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-145">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-146">
              Recent Activity
            </h3>
          </div>
          <div className="divide-y divide-gray-200" data-id="element-147">
            {recentActivity.map(activity => {
            const Icon = activity.icon;
            return <div key={activity.id} className="px-6 py-4 flex items-center" data-id="element-148">
                  <div className={`rounded-full p-2 ${activity.color}`} data-id="element-149">
                    <Icon className="h-5 w-5" data-id="element-150" />
                  </div>
                  <div className="ml-4 flex-1" data-id="element-151">
                    <p className="text-sm font-medium text-gray-900" data-id="element-152">
                      {activity.description}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-153">{activity.time}</p>
                  </div>
                  <button className="text-sm text-blue-600 hover:text-blue-800 font-medium" data-id="element-154">
                    View
                  </button>
                </div>;
          })}
          </div>
          <div className="px-6 py-4 border-t border-gray-200" data-id="element-155">
            <Link to="/activity" className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center justify-center" data-id="element-156">
              View all activity
            </Link>
          </div>
        </div>
        {/* Quick Actions */}
        <div className="bg-white rounded-lg shadow" data-id="element-157">
          <div className="px-6 py-5 border-b border-gray-200" data-id="element-158">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-159">
              {user.role === 'buyer' ? 'Recommended Products' : 'Potential Customers'}
            </h3>
          </div>
          <div className="p-6 space-y-6" data-id="element-160">
            {recommendations.map(item => <div key={item.id} className="flex items-center" data-id="element-161">
                <div className="h-12 w-12 flex-shrink-0" data-id="element-162">
                  <img className="h-12 w-12 rounded-md object-cover" src={item.image} alt={item.name} data-id="element-163" />
                </div>
                <div className="ml-4 flex-1 min-w-0" data-id="element-164">
                  <p className="text-sm font-medium text-gray-900 truncate" data-id="element-165">
                    {item.name}
                  </p>
                  <p className="text-sm text-gray-500 truncate" data-id="element-166">
                    {user.role === 'buyer' ? item.supplier : item.interest}
                  </p>
                </div>
                <div data-id="element-167">
                  <button className="text-sm text-blue-600 hover:text-blue-800 font-medium" data-id="element-168">
                    {user.role === 'buyer' ? 'View' : 'Connect'}
                  </button>
                </div>
              </div>)}
          </div>
          <div className="px-6 py-4 border-t border-gray-200" data-id="element-169">
            <Link to={user.role === 'buyer' ? '/products' : '/customers'} className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center justify-center" data-id="element-170">
              View all
            </Link>
          </div>
        </div>
      </div>
    </div>;
}